// Mock data for Doctimize website

export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      resolve({
        success: true,
        message: 'Ihre Anfrage wurde erfolgreich gesendet. Wir melden uns innerhalb von 24 Stunden bei Ihnen.'
      });
    }, 1000);
  });
};

export const pricingPlans = [
  {
    id: 1,
    name: 'Pilot-Partnerschaft',
    subtitle: 'Validierungsphase – Bis zu 15 Automationsstunden pro Monat',
    description: 'Ideal für erste strukturierte Prozesse und Testphase.',
    initialInvestment: '2\'900',
    monthlyPrice: '150',
    period: 'im ersten Jahr',
    featured: true,
    badge: 'Meistgewählt',
    availability: 'Nur noch 3 Plätze verfügbar',
    calLink: 'https://cal.eu/doctimize/besprechung-pilot-partnerschaft',
    features: [
      'Bis zu 15 Automationsstunden/Monat',
      'Erste Prozess-Validierung',
      'Strukturierte Testphase',
      'Basis-Support'
    ]
  },
  {
    id: 2,
    name: 'Early Access',
    subtitle: 'Bis zu 25 Automationsstunden pro Monat',
    description: 'Für Unternehmen mit regelmässigem Dokumentenvolumen.',
    initialInvestment: '5\'900',
    monthlyPrice: '250',
    availability: 'Nur noch 5 Plätze verfügbar',
    calLink: 'https://cal.eu/doctimize/besprechung-early-access',
    features: [
      'Bis zu 25 Automationsstunden/Monat',
      'Regelmässige Dokumentenverarbeitung',
      'Standard Support',
      'Monatliche Optimierungen'
    ]
  },
  {
    id: 3,
    name: 'Professional',
    subtitle: 'Bis zu 50 Automationsstunden pro Monat',
    description: 'Für wachsende Organisationen mit mehreren wiederkehrenden Dokumentenprozessen.',
    initialInvestment: '11\'900',
    monthlyPrice: '550',
    calLink: 'https://cal.eu/doctimize/besprechung-professional',
    features: [
      'Bis zu 50 Automationsstunden/Monat',
      'Multiple Dokumentenprozesse',
      'Priority Support',
      'Wöchentliche Optimierungen',
      'Dedizierter Account Manager'
    ]
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    title: 'PDFs hochladen',
    description: 'Laden Sie Ihre Dokumente einfach über die Plattform hoch'
  },
  {
    id: 2,
    title: 'Automatische Analyse',
    description: 'Dokumente werden automatisch ausgelesen und verarbeitet'
  },
  {
    id: 3,
    title: 'KI-Extraktion',
    description: 'KI extrahiert und strukturiert relevante Daten präzise'
  },
  {
    id: 4,
    title: 'Fertiges Dokument',
    description: 'Erhalten Sie ein strukturiertes Word-Dokument in Minuten'
  }
];

export const targetIndustries = [
  'Hypothekarberater',
  'Treuhandunternehmen',
  'Finanzdienstleister',
  'Immobilienunternehmen'
];

export const problemStats = {
  manualTime: 45,
  automatedTime: 2,
  dossiersPerMonth: 20,
  wastedHours: 15
};
